import { gql } from "@urql/core";

export const USERS_QUERY = gql`
  query {
    users {
      id
      username
      firstName
      lastName
      photoURL
      role
      authSessions {
        jwt
        refreshToken
        expired_at
        ip
        deviceType
        deviceModel
        deviceOs
        deviceClient
      }
      notificationSettings {
        id
        all
        confirmedTokens
        pendingTokens
        verifiedTokens
        tokenSocials
        keywords
        transactions
        approvals
        stdTokens
        devTokens
        liqTokens
      }
    }
  }
`;

export const UPDATE_USER_MUTATION = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      username
      firstName
      lastName
      photoURL
      role
    }
  }
`;
